import React from 'react'
import { parseURLParams } from '@offerzen/pinata'
import LoadingScene from '../../../CandidateExperience/scenes/LoadingScene'

const SocialSignupComplete = () => {
  const locationParams = parseURLParams(window.location.search)

  if (window.opener && 'auth_state' in locationParams) {
    window.opener.postMessage(locationParams, window.origin)
    window.close()
  }

  return <LoadingScene />
}

export default SocialSignupComplete
